<template>
  <v-row>

    <!-- <v-col cols="12">
      <p>User</p>
      <pre>
        {{ user }}
      </pre>
    </v-col>

    <v-col cols="12">
      <p>Data</p>
      <pre>
        {{ editions_entrepreneur }}
      </pre>
    </v-col> -->

    <!-- <v-dialog
      v-model="dialog"
      persistent
      max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Seleccione una Convocatoria:</span>
        </v-card-title>
        <v-card-text>

          <v-col cols="12">
            <label>Usted se encuentra registrado en más de una convocatoria, seleccione la convocatoria que quiere acceder:</label>
          </v-col>
          <v-col cols="12" v-for="item in convocation_form" :key="item.id">
            <v-btn
              block
              :loading="loading_btn"
              color="error"
              @click="select(item.id)"
            >
              {{ (item.title)?item.title:'(sin titulo)' }}
            </v-btn>
          </v-col>
          <v-col cols="12">
            <label>Para cambiar de convocatoria, cierre sesión y vuelva a ingresar.</label>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'HandleConvocationLogin',

    data: () => ({
      loading: true,
      loading_btn: false,
      dialog:false,

      data: [],
      editions_entrepreneur: [],
      convocation_form_data: [],
      convocation_selected:null,
      participants_profiles: [],
      last_edition: null,
      edition:null,
      editions:null,
    }),

    computed: {
      ...mapGetters([ 
        'isLogged', 'user', 'drawer', 'edition_id', 'convocation_form'
      ])
    },

    methods:{
      async checkRoles(){
        const userRoles = this.user.roles;
        let redirectRoute = '';

        switch (true) {
          case userRoles.includes('entrepreneur'):
            this.checkEntrepreneur();
            break;
          case userRoles.includes('participant'):
            this.getInfoParticipant();
            break;
          case userRoles.includes('admin'):
            redirectRoute = 'editions';
            break;
            case userRoles.includes('evaluator'):
            redirectRoute = 'EntrepreneurshipsAssigned';
            break;
          case userRoles.includes('tutor'):
            redirectRoute = 'EntrepreneurshipsAssignedTutors';
            break;
          case userRoles.includes('organizer'):
            redirectRoute = 'entrepreneurshipsOrganizer';
            break;
        }

        if (redirectRoute) {
          this.$store.dispatch('Logged', { is_logged: true });
          this.loading = false;
          this.$router.push({ name: redirectRoute });
        }
      },

      //----------------------------------------------------------------------------------
      //----------------------ENTREPRENEUR ROL--------------------------------------------
      //----------------------------------------------------------------------------------

      async checkEntrepreneur(){
        Promise.all([
          this.loading = false,
          this.getEditionsEntrepreneur()

        ]).then(() => {
          this.loading = false
        });
      },

      async getEditionsEntrepreneur(){
        
        this.$store.dispatch('setDrawer', false);
        localStorage.removeItem('convocation_form')
        localStorage.removeItem('edition')

        await axios.get('editions-entrepreneur').then(response => {
          this.data = response.data
          this.editions_entrepreneur = response.data

          this.convocation_form_data = response.data.data.convocation_form
          this.edition = response.data.data.edition

          localStorage.setItem('convocation_form_id', this.convocation_form_data.id);
          localStorage.setItem('edition_id', this.convocation_form_data.edition_id);
          localStorage.setItem('convocation_form', this.convocation_form_data);
          localStorage.setItem('edition', this.edition);
          
          this.$store
            .dispatch('convocationForm', {
              convocation_form: this.convocation_form_data
            })
          
          this.$store
            .dispatch('edition', {
              edition: this.edition
            })

          this.$store
            .dispatch('edition_id', {
              edition_id: this.convocation_form_data.edition_id
            })

          this.$store
            .dispatch('Logged', {
              is_logged: true
            })
          this.$store.dispatch('setDrawer', true);

          this.$router.push({ name: 'home' })
        })
      },

      //----------------------------------------------------------------------------------
      //-----------------------PARTICIPANT ROL--------------------------------------------
      //----------------------------------------------------------------------------------
      
      async getInfoParticipant(){
        await axios.get('participant/info-edition').then(response => {
          this.participants_profiles = response.data.data.participants_profiles

          this.$store
            .dispatch('edition_id', {
              edition_id: this.participants_profiles[0].edition_id
            })

          this.getLastEdition()
        }).catch(()=>{
          this.$router.push({ name: 'login' })
        })
      },

      async getLastEdition(){
        await axios.get('edition/last-edition').then(response => {
          this.last_edition = response.data.data.edition

          this.$store
              .dispatch('edition', {
                edition: this.last_edition
              })

          this.$store
            .dispatch('drawer', {
              drawer: true
            })

          this.$store
            .dispatch('Logged', {
              is_logged: true
            })
          
          // if(this.last_edition.waiting_room==true){
          //   this.$router.push({ name: 'WaitingRoom' , params: { slug: this.last_edition.slug } })
          // }
          this.$router.push({ name: 'home' })
        })
        this.loading = false
      }
    },

    created(){
      this.checkRoles()
    },
  }
</script>